import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    endpoints: Array,
  };

  connect() {
    this.initServiceWorker();
  }

  controllerChange(event) {
    navigator.serviceWorker.controller.addEventListener(
      "statechange",
      this.stateChange.bind(this)
    );
  }

  stateChange() {
    console.log("state change");
    // perform any visual manipulations here
  }

  sendSubscriptionToServer(subscription) {
    // Extract necessary subscription data
    // const endpoint = subscription.endpoint;
    // const p256dh = btoa(
    //   String.fromCharCode.apply(
    //     null,
    //     new Uint8Array(subscription.getKey("p256dh"))
    //   )
    // );
    // const auth = btoa(
    //   String.fromCharCode.apply(
    //     null,
    //     new Uint8Array(subscription.getKey("auth"))
    //   )
    // );
    // body: JSON.stringify({ endpoint, p256dh, auth }),

    fetch("/drivers_app/push_subscriptions", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content"),
      },
      body: JSON.stringify({
        push_subscription: subscription.toJSON(),
      }),
    })
      .then((response) => {
        if (response.ok) {
          console.log("Subscription successfully saved on the server.");
        } else {
          console.error("Error saving subscription on the server.");
        }
      })
      .catch((error) => {
        console.error("Error sending subscription to the server:", error);
      });
  }

  /* Initializations */
  async initServiceWorker() {
    let serviceWorkerRegistration;

    // Check if the browser supports service workers
    if ("serviceWorker" in navigator) {
      if (false) {
        //navigator.serviceWorker.controller) {
        serviceWorkerRegistration = await navigator.serviceWorker.ready;

        // If the service worker is already running, skip to state change
        this.stateChange();
      } else {
        // Register the service worker, and wait for it to become active
        serviceWorkerRegistration = await navigator.serviceWorker.register(
          "/service-worker.js",
          { scope: "./" }
        );

        navigator.serviceWorker.addEventListener(
          "controllerchange",
          this.controllerChange.bind(this)
        );
      }

      await this.initPushNotifications(serviceWorkerRegistration);
    } else {
      console.warn("Service workers not supported.");
    }
  }

  async initPushNotifications(serviceWorkerRegistration) {
    if ("Notification" in window) {
      // Request permission from the user to send notifications
      const permission = await Notification.requestPermission();

      if (permission === "granted") {
        // If permission is granted, subscribe to push notifications
        await this.activatePushManager(serviceWorkerRegistration);
      } else if (permission === "denied") {
        console.warn("User rejected to allow notifications.");
      } else {
        console.warn("User still didn't give an answer about notifications.");
      }
    } else {
      console.warn("Push notifications not supported.");
    }
  }

  async activatePushManager(serviceWorkerRegistration) {
    // Check if a subscription to push notifications already exists
    const existingSubscription =
      await serviceWorkerRegistration.pushManager.getSubscription();

    if (existingSubscription) {
      if (!this.endpointsValue.includes(existingSubscription.endpoint)) {
        this.sendSubscriptionToServer(existingSubscription);
      }
    } else {
      const subscription =
        await serviceWorkerRegistration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: window.vapidPublicKey,
        });

      // Save the subscription on the server
      this.sendSubscriptionToServer(subscription);
    }
  }
}
